export default "__VITE_ASSET__D18ZXl9c__"